import PaymentMethodManager from "../../../../components/PaymentMethodManager/PaymentMethodManager";

const PaymentMethodPage = () => {
  return (
    <PaymentMethodManager wizardMode={false} />
  );
};

export default PaymentMethodPage;